import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import React, { useContext } from 'react';
import classNames from 'classnames';
import './index.less';

var ProCardDivider = function ProCardDivider(props) {
  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('pro-card-divider');
  var className = props.className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      type = props.type;
  var classString = classNames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(type), type));
  return /*#__PURE__*/React.createElement("div", {
    className: classString,
    style: style
  });
};

export default ProCardDivider;